import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HotelIcon from '@mui/icons-material/Hotel';
import PersonIcon from '@mui/icons-material/Person';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import {
  WALK_IN_ACCENT,
  getWalkInMobileStepBarContainerSx,
  getWalkInMobileStepIconSx,
  getWalkInMobileStepItemSx,
  getWalkInMobileStepLabelSx,
} from '../../utils/walkInMobileLayout';

const DEFAULT_STEP_ICONS = [HotelIcon, PersonIcon, FactCheckIcon];

const WalkInMobileStepBar = ({ steps, activeStep, accentColor = WALK_IN_ACCENT, stepIcons = DEFAULT_STEP_ICONS }) => {
  return (
    <Box sx={getWalkInMobileStepBarContainerSx(accentColor)} role="tablist" aria-label="Booking steps">
      {steps.map((step, index) => {
        const isActive = index === activeStep;
        const isCompleted = index < activeStep;
        const Icon = stepIcons[index] || DEFAULT_STEP_ICONS[index];
        const label = step.shortLabel || step.label;

        return (
          <Box
            key={step.label}
            role="tab"
            aria-selected={isActive}
            sx={getWalkInMobileStepItemSx(isActive, isCompleted, accentColor)}
          >
            <Box sx={getWalkInMobileStepIconSx(isActive, isCompleted, accentColor)}>
              {isCompleted ? (
                <CheckCircleIcon fontSize="inherit" />
              ) : isActive && Icon ? (
                <Icon sx={{ fontSize: 14, color: '#0a0f1a' }} />
              ) : (
                index + 1
              )}
            </Box>
            <Typography sx={getWalkInMobileStepLabelSx(isActive, isCompleted)}>
              {label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default WalkInMobileStepBar;
